export class SpecifiedPoolApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getSpecifiedPools(params) {
    return this.#http.get('/api/specified-pools', { params });
  }

  async getSpecifiedPool(id) {
    return this.#http.get(`/api/specified-pools/${id}`);
  }

  async createSpecifiedPool(body) {
    return this.#http.post('/api/specified-pools', body);
  }

  async updateSpecifiedPool(id, body) {
    return this.#http.put(`/api/specified-pools/${id}`, body);
  }

  async deleteSpecifiedPool(id) {
    return this.#http.delete(`/api/specified-pools/${id}`);
  }

  async cloneSpecifiedPool(id, body) {
    return this.#http.post(`/api/specified-pools/${id}/clone`, body);
  }
}
